import t from "./index823.js";
import e from "./index815.js";
var s = "[object Arguments]";
function m(r) {
  return e(r) && t(r) == s;
}
export {
  m as default
};
